module.exports = __webpack_public_path__ + "static/media/ppglogo.de36e334.png";